import { useAuth } from '@/contexts/AuthContext';
import { Navigate, Outlet } from 'react-router-dom';

const ProtectedRoute = () => {
  const { user, loading } = useAuth();

  if (loading) {
    // Show loading while checking authentication
    return <div>Loading...</div>;
  }

  if (!user?.isAdmin) {
    // Redirect them to the home page if they are not an admin
    return <Navigate to="/" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;